import { render, staticRenderFns } from "./resume-cta.vue?vue&type=template&id=ceced6d6&scoped=true"
import script from "./resume-cta.vue?vue&type=script&lang=js"
export * from "./resume-cta.vue?vue&type=script&lang=js"
import style0 from "./resume-cta.vue?vue&type=style&index=0&id=ceced6d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceced6d6",
  null
  
)

export default component.exports